import React from 'react';
import { ICreatorFieldsFragment } from '../../utils/apollo/graphqlSchema';
import Avatar from '../Avatar';
import KubitTooltip from '../KubitTooltip';

interface IProps {
  user: ICreatorFieldsFragment;
  contentLabel: string;
  contentSuffix?: string;
}

const PermissionUserInfo = ({ user, contentLabel, contentSuffix }: IProps) => {
  return (
    <KubitTooltip
      content={`${contentLabel}: ${user.name}${contentSuffix ?? ''}`}
      noOpenDelay={true}
      placement="bottom-end"
    >
      <Avatar picture={user.picture} size={20} />
    </KubitTooltip>
  );
};

export default PermissionUserInfo;
